import { useState } from "react";
import axios from "../../axios";

// Кнопка «посилання на бота» для адмінки: генерує особисте посилання (учень / пробний) і копіює його.
// Лера вставляє посилання в повідомлення людині. Поруч — статус: підключено / доступ отримано.
// again — підпис кнопки, щоб видати посилання ще раз, коли вже done (пробний загубив пароль, другий Telegram для учня).
export default function BotLinkButton({ kind, id, done, doneText, hint, again }) {
  const [state, setState] = useState("");
  const copy = async () => {
    try {
      setState("…");
      const { data } = await axios.post("admin/bot/link", { kind, id });
      try { await navigator.clipboard.writeText(data.url); }
      catch { const t = document.createElement("textarea"); t.value = data.url; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove(); }
      setState("✅ Скопійовано");
      setTimeout(() => setState(""), 2500);
    } catch {
      setState("⚠️ Помилка");
    }
  };
  return (
    <span style={{ display: "inline-flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      {done && <span style={{ color: "#1f8a4c", fontWeight: 700, fontSize: "0.85rem" }}>{doneText}</span>}
      {(!done || again) && (
        <button type="button" onClick={copy} title={hint}
          style={{ border: "1px solid #dcd7ee", background: "#fff", borderRadius: 8, padding: "5px 10px", cursor: "pointer", font: "inherit", fontSize: "0.82rem", fontWeight: 700, whiteSpace: "nowrap" }}>
          🤖 {state || (done ? again : "Посилання на бот")}
        </button>
      )}
    </span>
  );
}
